import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

export type ImportResultType = "success" | "partial" | "error";

export interface ImportSheetIssue {
  id: string;
  reason: string;
}

export interface ImportResultConfig {
  type: ImportResultType;
  title: string;
  subTitle?: string;
  notFoundInFile?: string[];
  notFoundInTestSuite?: string[];
  invalidSheets?: ImportSheetIssue[];
}

@Component({
  selector: "app-import-result-modal",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./import-result-modal.component.html",
  styleUrl: "./import-result-modal.component.scss",
})
export class ImportResultModalComponent {
  @Input() config!: ImportResultConfig;

  readonly activeModal = inject(NgbActiveModal);

  get hasFailures(): boolean {
    return (
      (this.config?.notFoundInFile?.length ?? 0) > 0 ||
      (this.config?.notFoundInTestSuite?.length ?? 0) > 0 ||
      (this.config?.invalidSheets?.length ?? 0) > 0
    );
  }
}
